/* FÉNIX R07.58 — concise hero plaque copy */
(function(){
  function refine(){
    var plaque=document.querySelector('body.template-index .fnx-c02-stage__meta');
    if(!plaque) return;
    var title=plaque.querySelector('strong');
    if(title) title.textContent='Noopept · 30 mg · 60 píldoras';
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',refine,{once:true});
  else refine();
})();
